import { createAction } from '../../../store.model';
import { ActionType } from '../main.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ShowPopulationGroupDialog {}

export const showPopulationGroupDialog = createAction<
    ActionType,
    ShowPopulationGroupDialog
>(ActionType.MI2_MAIN__SHOW_POPULATION_GROUP_DIALOG);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HidePopulationGroupDialog {}

export const hidePopulationGroupDialog = createAction<
    ActionType,
    HidePopulationGroupDialog
>(ActionType.MI2_MAIN__HIDE_POPULATION_GROUP_DIALOG);
